import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import AddCompletedASQModal from './AddCompletedASQModal';
import { closeIconPath } from './ModalRoot';

const AddCompletedASQModalWrapper = ({ open, onClose, onSuccess, closeOnOverlayClick, ...modalProps }) => (
  <Modal
    classNames={{ overlay: 'o-modal__wrap', modal: 'o-modal' }}
    styles={{ modal: { maxWidth: 520, width: '100%', borderRadius: 6, overflow: 'visible' } }}
    closeIconSvgPath={closeIconPath()}
    closeOnOverlayClick={closeOnOverlayClick}
    open={open}
    onClose={onClose}
    center
  >
    <AddCompletedASQModal
      onClose={onClose}
      onSuccess={onSuccess}
      {...modalProps}
    />
  </Modal>
);

AddCompletedASQModalWrapper.defaultProps = {
  closeOnOverlayClick: true,
};

AddCompletedASQModalWrapper.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  closeOnOverlayClick: PropTypes.bool,
};

export default AddCompletedASQModalWrapper;
